<div class="card mb-3" *ngIf="event">
  <div class="card-header text-white bg-primary text-center sticky-title">
    Général
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-12 py-1">
        <span
          class="badge"
          [ngStyle]="{'color': event.color_front, 'backgroundColor': event.color_back, 'borderRadius': '5px'}">
          {{ event.cal_summary }}
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 col-lg-8 col-sm-12 py-1">
        <label>Nom de l'événement</label>
        <input
          disabled
          id="nomEvenement"
          type="text"
          [(ngModel)]="event.summary"
          class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Date</label>
        <input
          disabled
          id="date"
          type="text"
          [(ngModel)]="event.date_start"
          class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Formule</label>
        <select
          (change)="onFormuleChange()"
          class="form-select"
          id="formule"
          [disabled]="!editable"
          [(ngModel)]="event.formule">
          <option value="">Sélectionner une formule</option>
          <option *ngFor="let formule of formules" [value]="formule">
            {{ formule }}
          </option>
        </select>
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Code Postal</label>
        <input
          [disabled]="!editable"
          id="codePostal"
          type="text"
          [(ngModel)]="event.codePostal"
          class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Ville</label>
        <input
          [disabled]="!editable"
          id="ville"
          type="text"
          [(ngModel)]="event.ville"
          class="form-control" />
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <div class="row">
          <div class="col text-center">
            <label>Payant ?</label>
            <div class="form-check form-switch">
              <input
                [disabled]="!editable"
                id="payant"
                type="checkbox"
                [(ngModel)]="event.payant"
                class="form-check-input" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Repas</label>
        <select class="form-select" id="repas" [disabled]="!editable" [(ngModel)]="event.repas">
          <option value="0"></option>
          <option value="1">Prévu Orga</option>
          <option value="2">Collectif Saugrenue</option>
          <option value="3">Pas de repas</option>
        </select>
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Suivi Devis / Contrat</label>
        <select
          class="form-select"
          id="suiviDevisContrat"
          [disabled]="!editable"
          [(ngModel)]="event.suiviDevisContrat">
          <option value="0"></option>
          <option value="1">Devis envoyé</option>
          <option value="2">Contrat envoyé</option>
          <option value="3">Confirmé</option>
          <option value="5">En direct</option>
          <option value="4">Annulé/Supprimé</option>
        </select>
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Montant H.T.</label>
        <div class="input-group">
          <input
            [disabled]="!editable"
            id="montant"
            type="text"
            [(ngModel)]="event.montant"
            class="form-control" />
          <div class="input-group-append">
            <span class="input-group-text">€</span>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label>Cachet Net Musicien</label>
        <div class="input-group">
          <input
            [disabled]="!editable"
            id="cachet"
            type="text"
            class="form-control" />
          <div class="input-group-append">
            <span class="input-group-text">€</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
